import { TokenPairDto } from "services/auth/restModels";

const TOKEN_STORAGE_KEY = "token";

export const getToken = () => {
    const stored = localStorage.getItem(TOKEN_STORAGE_KEY);

    if (!stored) return "";

    return (JSON.parse(stored) as TokenPairDto).authToken;
};

export const saveTokenPair = (token: TokenPairDto) => {
    if (!token) return;

    localStorage.setItem(TOKEN_STORAGE_KEY, JSON.stringify(token));
};

/*
* Вход по ссылке (?authToken=... из письма о регистрации): срок нам не сообщают, ставим ноль —
* его всё равно никто не читает, живость токена проверяет бэк.
* */
export const saveAuthToken = (authToken: string) => {
    saveTokenPair({ authToken, authTokenExpiresAt: 0 });
};

export const removeTokenPair = () => {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
};
